import { notificationTypeToCategoryId } from "@/lib/constants";
import {
  NotificationFilterState,
  NotificationInboxFilter,
  NotificationResponse,
} from "@/types";

/**
 * Filters notifications based on the provided filter state.
 * This is the single source of truth for notification list filtering logic.
 */
export function filterNotifications(
  notifications: NotificationResponse[],
  filterState: NotificationFilterState,
): NotificationResponse[] {
  const categoryIdsSet = new Set(filterState.categoryIds);
  const normalizedQuery = filterState.searchQuery.trim().toLowerCase();

  return notifications.filter((notification) => {
    // Not in the notification catalog, so this type is not supposed to be
    // rendered on the frontend or in Staffer at all
    if (!notificationTypeToCategoryId[notification.type]) {
      return false;
    }

    // If only showing unread, and notification has been read, filter it out
    if (
      filterState.inboxFilter === NotificationInboxFilter.UNREAD &&
      notification.readAt !== null
    ) {
      return false;
    }

    // Scoped to specific types (e.g. the sidebar's excellent-candidate row)
    if (
      filterState.types.length > 0 &&
      !filterState.types.includes(notification.type)
    ) {
      return false;
    }

    // Filter on a notification category (instant, batched, or team)
    if (categoryIdsSet.size > 0) {
      const categoryId = notificationTypeToCategoryId[notification.type];
      if (!categoryId || !categoryIdsSet.has(categoryId)) {
        return false;
      }
    }

    // Filter on what's entered in search bar - should match title or content of the notification
    if (normalizedQuery) {
      const matchesTitle = notification.title
        .toLowerCase()
        .includes(normalizedQuery);
      const matchesContent = notification.content
        .toLowerCase()
        .includes(normalizedQuery);
      if (!matchesTitle && !matchesContent) {
        return false;
      }
    }

    return true;
  });
}
